<div class="dialog-header">
  <div class="header-title">
    <span class="header-span">Column Editor</span>
  </div>

  <div class="buttons-block">
    <button class="header-button send-button" mat-button (click)="saveDict()" [disabled]="saveLoading"
            [ngClass]="{'disabled-button': saveLoading}">
      <span *ngIf="!saveLoading">Save</span>
      <lib-mini-progress-spinner *ngIf="saveLoading"></lib-mini-progress-spinner>
    </button>
  </div>

  <button mat-button class="close-button-container" disableRipple="true" (click)="closeDialog()">
    <mat-icon>clear</mat-icon>
  </button>
</div>

<div class="middle-content">
  <div class="inputs-block">
    <div class="input-block">
      <div class="input-label">Name:</div>

      <div class="email-input-text">
        <input class="arrow-input" type="text" pInputText BlockLateralArrowNavigation [ngModelOptions]="{standalone: true}" [(ngModel)]="tempColumn.name">
      </div>
    </div>

    <div class="input-block">
      <div class="input-label">Dropbox Path:</div>

      <div class="email-input-text">
        <input class="arrow-input" type="text" pInputText BlockLateralArrowNavigation [ngModelOptions]="{standalone: true}"
               [disabled]="saveLoading" [(ngModel)]="tempColumn.dbxFolder">
      </div>
    </div>

    <div class="input-block">
      <div class="input-label">Dropbox Group By Year:</div>

      <div class="email-input-text">
        <p-inputSwitch [ngModelOptions]="{standalone: true}" [(ngModel)]="tempColumn.syncWithMainSystem">
        </p-inputSwitch>
      </div>
    </div>

    <div class="input-block">
      <div class="input-label">Sync With Main System:</div>

      <div class="email-input-text">
        <p-inputSwitch [ngModelOptions]="{standalone: true}" [(ngModel)]="tempColumn.syncWithMainSystem">
        </p-inputSwitch>
      </div>
    </div>


  </div>
</div>
